import http from "../components/http";
import { Maquina } from "../interfaces/maquina.interface";

// Buscar todas as máquinas
export const fetchMaquinas = async (): Promise<Maquina[]> => {
    const response = await http.get(`/maquinas`);
    return response.data;
};

// Buscar uma máquina por ID
export const fetchMaquina = async (id: string): Promise<Maquina> => {
    const response = await http.get(`/maquinas/${id}`);
    return response.data;
};

// Criar uma nova máquina
export const createMaquina = async (maquina: Maquina): Promise<Maquina> => {
    let response;
    try {
        response = await http.post(`/maquinas`, maquina);
    } catch (error) {
        console.error("Erro ao criar máquina:", error);
    }
    return response?.data;
};

// Atualizar uma máquina existente
export const updateMaquina = async (id: string, maquina: Maquina): Promise<Maquina> => {
    const response = await http.put(`/maquinas/${id}`, maquina);
    return response.data;
};

// Deletar uma máquina
export const deleteMaquina = async (id: string): Promise<void> => {
    await http.delete(`/maquinas/${id}`);
};
